/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsTotalAwaitingNodesCountRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsTotalAwaitingNodesCountRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalAwaitingNodesCountRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsTotalAwaitingNodesCountRequest$Outbound = {
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsTotalAwaitingNodesCountRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalAwaitingNodesCountRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsTotalAwaitingNodesCountRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalAwaitingNodesCountRequest$ {
  /** @deprecated use `GetApiV3MetricsTotalAwaitingNodesCountRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalAwaitingNodesCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalAwaitingNodesCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalAwaitingNodesCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalAwaitingNodesCountRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsTotalAwaitingNodesCountRequest$Outbound;
}

export function getApiV3MetricsTotalAwaitingNodesCountRequestToJSON(
  getApiV3MetricsTotalAwaitingNodesCountRequest:
    GetApiV3MetricsTotalAwaitingNodesCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsTotalAwaitingNodesCountRequest$outboundSchema.parse(
      getApiV3MetricsTotalAwaitingNodesCountRequest,
    ),
  );
}

export function getApiV3MetricsTotalAwaitingNodesCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsTotalAwaitingNodesCountRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsTotalAwaitingNodesCountRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsTotalAwaitingNodesCountRequest' from JSON`,
  );
}
